import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRateAnalyticsThunk,
  setSelectedBranch,
} from "../../../store/thunks/rateThunks";
import RateHistoryChart from "../../../components/Rates/RateHistoryChart";
import { useCurrentBranch } from "../../../hooks/useCurrentBranch";
import BranchSelector from "../../../components/UI/BranchSelector";

const RateAnalytics = () => {
  const dispatch = useDispatch();
  const { analytics, loading } = useSelector((state) => state.rate);
  const { currentBranch, hasBranchAccess } = useCurrentBranch();

  useEffect(() => {
    if (currentBranch) {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);

      dispatch(
        getRateAnalyticsThunk({
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          branchCode: currentBranch,
        })
      );
    }
  }, [dispatch, currentBranch]);

  const handleBranchChange = (branchCode) => {
    // This will trigger the useEffect to reload analytics
    dispatch(setSelectedBranch(branchCode));
  };

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold mb-2">Rate Analytics</h1>
            <p className="text-gray-600">Track rate trends and patterns</p>
          </div>
          <BranchSelector
            selectedBranch={currentBranch}
            onBranchChange={handleBranchChange}
          />
        </div>
      </div>

      {!hasBranchAccess ? (
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <p className="text-gray-500">
            Please select a branch to view analytics
          </p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="text-sm font-medium text-gray-600">
                Total Changes
              </h3>
              <p className="text-3xl font-bold mt-2">
                {analytics.data?.totalChanges || 0}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Branch: {currentBranch}
              </p>
            </div>
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="text-sm font-medium text-gray-600">
                Avg Deviation
              </h3>
              <p className="text-3xl font-bold mt-2">
                {analytics.data?.averageDeviation || 0}%
              </p>
            </div>
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="text-sm font-medium text-gray-600">
                Mode Distribution
              </h3>
              <div className="mt-2 space-y-1">
                {Object.entries(analytics.data?.modeDistribution || {}).map(
                  ([mode, count]) => (
                    <div key={mode} className="flex justify-between text-sm">
                      <span>{mode}</span>
                      <span className="font-semibold">{count}</span>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          <RateHistoryChart branchCode={currentBranch} />
        </>
      )}
    </div>
  );
};

export default RateAnalytics;
